"use client";

import { type Pricelist, TAGS } from "@raumagarn/formatters";
import { clsx } from "@trydig/ui";
import { usePrice } from "~/lib/hooks/usePrice";
import styles from "./product-tag.module.css";

/**
 * Client-side component that displays a sale tag when a product is on sale,
 * or a free tag when a product is free.
 * Uses the selection price list to determine sale/free status.
 * @param prices
 * @returns Sale/Free tag element if applicable, null otherwise
 */
export const ClientSaleTag = ({ pricelist }: { pricelist: Pricelist }) => {
	const { priceAsNumber, showAsOnSale } = usePrice({ pricelist });

	// Check if product is free (price is 0)
	if (priceAsNumber === 0) {
		return <span className={clsx(styles.tag, styles.free)}>{TAGS.free}</span>;
	}

	// Check if product is on sale
	if (showAsOnSale) {
		return <span className={clsx(styles.tag, styles.sale)}>{TAGS.sale}</span>;
	}

	return null;
};
